// Lib
import React, { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

// Modules
import CustomDomainProfile from '@modules/Profile/components/CustomDomainProfile';

const CustomDomainUI: React.FC = () => {
  useEffect(() => {
    const body = document?.body;
    if (body) body.style.overflowY = 'hidden';
    const root = document.getElementById('root');
    const splashLogo = document.getElementById('splash-logo');
    const splashSpinner = document.getElementById('splash-spinner');
    window.onload = function (): void {
      if (body) body.style.overflowY = '';
      if (root) root.style.visibility = 'unset';
      if (splashLogo) splashLogo.style.display = 'none';
      if (splashSpinner) splashSpinner.style.display = 'none';
    };
  }, []);

  return (
    <div
      id="react-ui-wrapper"
      className="flex h-screen w-full overflow-hidden max-[1279px]:h-auto max-[1279px]:w-auto max-[1279px]:overflow-auto max-[743px]:[&_.sidebar]:hidden"
    >
      <div
        id="body-wrapper"
        className="relative h-full w-full overflow-auto [scrollbar-width:none] max-[1279px]:min-h-screen max-[1279px]:flex-col max-[743px]:min-h-screen max-[743px]:pb-[60px] [&::-webkit-scrollbar]:hidden"
      >
        <Routes>
          <Route path="/" element={<CustomDomainProfile />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default CustomDomainUI;
